import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "../store";

const selectAdminLeavesState = (state: RootState) => state.adminLeaves;

export const selectAdminLeaves = createSelector(
  [selectAdminLeavesState],
  (s) => s.list,
);

export const selectAdminLeavesStats = createSelector(
  [selectAdminLeavesState],
  (s) => s.stats,
);

export const selectAdminLeavesPagination = createSelector(
  [selectAdminLeavesState],
  (s) => s.pagination,
);

export const selectAdminLeavesFilters = createSelector(
  [selectAdminLeavesState],
  (s) => s.filters,
);

export const selectAdminLeavesActiveCompany = createSelector(
  [selectAdminLeavesState],
  (s) => s.activeCompany,
);

export const selectAdminLeavesCompanies = createSelector(
  [selectAdminLeavesState],
  (s) => s.companies,
);

export const selectAdminLeavesEmployees = createSelector(
  [selectAdminLeavesState],
  (s) => s.employees,
);

export const selectAdminLeaveTypes = createSelector(
  [selectAdminLeavesState],
  (s) => s.leaveTypes,
);

export const selectAdminLeavesLoading = createSelector(
  [selectAdminLeavesState],
  (s) => s.loading,
);

export const selectAdminLeavesError = createSelector(
  [selectAdminLeavesState],
  (s) => s.error,
);
